module.exports = __webpack_public_path__ + "static/media/tools-video.bb6e9451.svg";